var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionTicketRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 4a2 2 0 012 2v7s-3 0-3 3 3 3 3 3v7a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h22zm-7 16v4h2v-4h-2zM8 18v2h9v-2H8zm12-4v4h2v-4h-2zM8 12v2h9v-2H8zm12-4v4h2V8h-2z",
    fill: "#000"
  })));
}

export default SvgIconPromotionTicketRexFilled;